import { Directive, Renderer2, inject, OnInit, DestroyRef } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appLanguage]',
  standalone: true,
})
export class AppLanguageDirective implements OnInit {
  private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);
  private destroyRef = inject(DestroyRef);
  private languageService = inject(LanguageService);
  private localeChange$ = toObservable(this.languageService.locale);

  ngOnInit() {
    this.updateLanguageAttribute();

    this.localeChange$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.updateLanguageAttribute();
      });
  }

  private updateLanguageAttribute(): void {
    const locale = this.languageService.locale();
    const languageCode = this.extractLanguageCode(locale);

    this.renderer.setAttribute(this.document.documentElement, 'lang', languageCode);
  }

  private extractLanguageCode(locale: string): string {
    return locale.split('-')[0];
  }
}
